import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { AllCapsSubheader, BasicInfoBox, GreyText, NoneFoundText, Subtitle } from '../../../styles';
import { Box } from '@mui/material';
import { CertificatesProps } from 'features/Principal/types/modalTypes';

export const Certificates: React.FC<CertificatesProps> = ({ certificates }) => {
  return (
    <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.CERTIFICATES_SECTION}>
      <AllCapsSubheader sx={{ pt: 2 }}>Certificates</AllCapsSubheader>
      {certificates.length == 0 && <NoneFoundText>No certificates found</NoneFoundText>}
      {certificates?.map((certificate, index) => {
        return (
          <BasicInfoBox
            key={index}
            data-testid={ATSPrincipalAppCandidateModalTabsTestIds.INDIVIDUAL_CERTIFICATE}
          >
            <Subtitle>{certificate.label}</Subtitle>
            {certificate.other_certificate_explanation && (
              <GreyText>{certificate.other_certificate_explanation}</GreyText>
            )}
          </BasicInfoBox>
        );
      })}
    </Box>
  );
};
